import { PropsWithChildren } from "react";
import React from "react";
import Header from "../components/layout/header";
import NavBar from "../components/layout/navBar";
import Footer from "../components/layout/footer";
import SandboxBar from "../components/layout/sandbox-bar";

interface BaseProps extends PropsWithChildren<any> {
    requiredString?: string,
    requiredNumber?: number,
    optionalBoolean?: boolean,
    optionalString?: string,
    optionalNumber?: number,
}

const defaultProps: BaseProps = {
    requiredString: '',
    requiredNumber: 0,
    optionalBoolean: true,
    optionalString: 'default',
    optionalNumber: 42,
}


const BaseComponent: React.FC<BaseProps> = (props) => {
    return (
        <React.Fragment>
            <Header />
            <NavBar />
            {props.children}
            <Footer />
            <SandboxBar />
        </React.Fragment>
    );
};

BaseComponent.defaultProps = defaultProps;

export default BaseComponent;
